module.exports = {"amp":"&","apos":"'","gt":">","lt":"<","quot":"\""}


//////////////////
// WEBPACK FOOTER
// ./~/htmlparser2/lib/entities/xml.json
// module id = 195
// module chunks = 98320775592555 153940073825489